import React, { useState, useEffect } from "react";

import Grid from "./components/Grid";
import Banner from "./components/Banner";
import Filters from "./components/Filters";

import { usePosts } from "context/posts";

const Content = ({
  page_posts,
  pageContext,
  no_banner,
  search,
  no_pagination,
  category,
}) => {
  const { posts } = usePosts();

  const [query, setQuery] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(search);
      setQuery(params.get("query") || "");
    }
  }, [search]);

  let filtered_posts =
    page_posts ||
    posts?.filter((item) =>
      item?.categories?.nodes?.some((cat) => cat.slug !== "artykuly-partnerow")
    );

  if (!!query) {
    filtered_posts = posts?.filter(
      (item) =>
        item.title.toLowerCase().includes(query) ||
        item.content.toLowerCase().includes(query) ||
        item.title.toLowerCase().includes(query)
    );
  } else {
    if (!!!no_pagination) {
      filtered_posts = filtered_posts.slice(
        pageContext?.skip,
        pageContext?.skip + pageContext?.limit
      );
    }
  }

  return (
    <section className="blog-main">
      <div className="container">
        {!!!no_banner && <Banner />}
        <Filters category={category} hidePaginationInput={!!no_pagination} />
        <Grid
          list={filtered_posts}
          pageContext={pageContext}
          no_pagination={!!no_pagination}
        />
        {/* <div className="blog-main__post">
          {posts
            ?.filter((item) =>
              item?.categories?.nodes?.some(
                (cat) => cat?.slug !== "artykuly-partnerow"
              )
            )
            ?.slice(0, 1)
            ?.map((item, index) => (
              <NewsCardMain
                key={index}
                title={item.title}
                excerpt={item.excerpt}
                date={item.date}
                update={item?.acfPost?.postUpdateDate}
                url={item.uri}
                thumbnail={item.featuredImage?.node.sourceUrl}
                authorAvatar={item.author.node.avatar.url}
                authorName={`${item.author.node.firstName} ${item.author.node.lastName}`}
                categories={item.categories.nodes}
              />
            ))}
        </div> */}

        {/* <div className="blog-main__categories">
          <div className="blog-main__cat-text">Pokaż artykuły w kategorii:</div>
          <div className="blog-main__categories-container">
            <Link to="/blog/" className="current">
              Wszystkie
            </Link>
            {categories
              ?.filter((item) => item.slug !== "artykuly-partnerow")
              .map((item, index) => (
                <Link
                  to={`/blog/${item.slug}/`}
                  key={index}
                  className={item.slug}
                >
                  {item.name}
                </Link>
              ))}
            <Link to="/blog/artykuly-partnerow/" className="artykuly-partnerow">
              Artykuły partnerów
            </Link>
            <Link to="/quizy/" className="quizy">
              Darmowe Testy i Quizy
            </Link>
          </div>
        </div> */}

        {/* <div className="row align-items-center">
          <div className="col-lg-9">
            <form className="blog-main__search" onSubmit={formSubmit}>
              <div className="row align-items-center">
                <div className="col-md">
                  <p>Wpisz szukaną frazę:</p>
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    name="search"
                    onChange={(e) => setQuery(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md">
                  <button type="submit" className="button button--green">
                    Szukaj
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="col-lg-3">
            <div className="blog-main__pagination blog-main__pagination--top">
              <Pagination {...pageContext} />
            </div>
          </div>
        </div> */}

        {/* <Divider marginTop={45} marginBottom={45} /> */}

        {/* <div className="blog-main__posts">
          {posts
            ?.filter((item) =>
              item?.categories?.nodes?.some(
                (cat) => cat?.slug !== "artykuly-partnerow"
              )
            )
            .slice(1)
            .slice(pageContext?.skip, pageContext?.skip + pageContext?.limit)
            .map((item, index) => (
              <NewsCard
                key={index}
                title={item.title}
                excerpt={item.excerpt}
                date={item.date}
                update={item?.acfPost?.postUpdateDate}
                url={item.uri}
                thumbnail={item.featuredImage?.node.sourceUrl}
                authorAvatar={item.author.node.avatar.url}
                authorName={`${item.author.node.firstName} ${item.author.node.lastName}`}
                categories={item.categories.nodes}
              />
            ))}
        </div> */}

        {/* <div className="blog-main__pagination pagination--bottom">
          <Pagination {...pageContext} />
        </div> */}
      </div>
    </section>
  );
};

export default Content;
